import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/SearchMdIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M18 11.0001C18 7.13405 14.866 4.00006 11 4.00006C7.13398 4.00006 4 7.13405 4 11.0001C4 14.8661 7.13398 18.0001 11 18.0001C12.89 18.0001 14.6038 17.2497 15.8633 16.0323C15.8877 16.0013 15.9148 15.972 15.9434 15.9434C15.9719 15.9148 16.0012 15.8877 16.0322 15.8633C17.2497 14.6039 18 12.8901 18 11.0001ZM20 11.0001C20 13.125 19.2618 15.0766 18.0303 16.6163L21.707 20.293C22.0976 20.6836 22.0976 21.3166 21.707 21.7071C21.3165 22.0976 20.6835 22.0976 20.293 21.7071L16.6162 18.0303C15.0766 19.2619 13.125 20.0001 11 20.0001C6.02942 20.0001 2 15.9706 2 11.0001C2 6.02948 6.02942 2.00006 11 2.00006C15.9706 2.00006 20 6.02948 20 11.0001Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M7.33301 1.25006C10.6926 1.25006 13.4168 3.97347 13.417 7.33307C13.417 8.74256 12.9354 10.0389 12.1309 11.0704L14.5303 13.4698C14.8232 13.7627 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11.0703 12.1309C10.0389 12.9355 8.7425 13.4171 7.33301 13.4171C3.97341 13.4169 1.25 10.6927 1.25 7.33307C1.25018 3.97358 3.97352 1.25024 7.33301 1.25006ZM7.33301 2.75006C4.80195 2.75024 2.75018 4.80201 2.75 7.33307C2.75 9.86428 4.80184 11.9169 7.33301 11.9171C8.57109 11.9171 9.69381 11.4248 10.5186 10.627C10.5346 10.6074 10.551 10.5877 10.5693 10.5694C10.5878 10.5509 10.6071 10.5338 10.627 10.5176C11.4244 9.69294 11.917 8.5709 11.917 7.33307C11.9168 4.8019 9.86422 2.75006 7.33301 2.75006Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as SearchMdIcon };
